// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Gm5DR","img":"Loader_img__xYYMf","blickImg":"Loader_blickImg__nQw2h","opacityloader":"Loader_opacityloader__YjS-4"};